import API_ENDPOINT_CONSTANTS from "../constants/endpointConstants";
import { apiPost } from "../utils/apiUtils";

const loginService = (username: string, password: string) =>
  apiPost(API_ENDPOINT_CONSTANTS.LOGIN, { username, epassword: password });

const logoutService = (username: string) =>
  apiPost(API_ENDPOINT_CONSTANTS.LOGOUT, { username });

export { loginService, logoutService };
